var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.843 2.81L7.92.768a2.401 2.401 0 00-1.54-.011L1.65 2.32A2.352 2.352 0 00.039 4.537v13.825c0 1.645 1.67 2.765 3.223 2.17l3.472-1.33a1.16 1.16 0 01.817-.012l5.925 2.042a2.401 2.401 0 001.54.012l4.728-1.564a2.341 2.341 0 001.611-2.216V3.637c0-1.645-1.67-2.765-3.223-2.17l-3.471 1.33c-.261.094-.545.105-.818.012zm.415 16.229l-7.11-2.462V2.962l7.11 2.461v13.615z",
    fill: "inherit"
  })));
}

export default SvgMapinline;